export default {
	dashboard: {
		startBuilding: "Start Building",
		createAndLaunch:
			"Create and launch insurance products instantly. Configure pricing and underwriting rules and get auto-generated APIs. Build as many distribution apps as you need. All in nocode manner."
	}
}
